import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import { styled } from "@mui/system";
import { useTranslation } from "react-i18next";

// Static images (keep as-is)
const images = [
  "image/back.jpg",
  "image/11.jpg",
  "image/33.jpg",
  "image/44.jpg",
  "image/55.jpg",
];

// Styled card with enhanced 3D effect and glow on hover
const Card = styled("div")(({ theme }) => ({
  position: "relative",
  width: "100%",
  height: 350,
  borderRadius: 20,
  overflow: "hidden",
  backgroundColor: "#1e293b", // slate background
  border: "2px solid #334155",
  boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
  transition: "transform 0.4s ease, box-shadow 0.4s ease",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  perspective: 1000,
  cursor: "pointer",

  "&:hover": {
    transform: "scale(1.07) rotateX(6deg) rotateY(6deg)",
    boxShadow: "0 25px 45px rgba(0, 0, 0, 0.4)",
  },
  "&:hover .drawer": {
    transform: "translateY(0)",
    opacity: 1,
  },
}));

const CardImage = styled("img")({
  maxWidth: "100%",
  maxHeight: "100%",
  objectFit: "cover",
  display: "block",
  transition: "transform 0.4s ease",
});

const DrawerOverlay = styled(Box)(({ theme }) => ({
  position: "absolute",
  bottom: 0,
  width: "100%",
  height: "40%",
  background: "linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0.2))",
  color: "#fff",
  backdropFilter: "blur(4px)",
  padding: 16,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  transition: "all 0.4s ease",
  transform: "translateY(100%)",
  opacity: 0,
  borderTopLeftRadius: 20,
  borderTopRightRadius: 20,
  zIndex: 2,
  [theme.breakpoints.down("sm")]: {
    transform: "translateY(0)",
    opacity: 1,
  },
}));

const MemberName = styled(Typography)({
  fontWeight: 700,
  fontSize: "1.2rem",
  color: "#fff",
  textAlign: "center",
  textShadow: "1px 1px 4px rgba(0, 0, 0, 0.7)",
});

const MemberRole = styled(Typography)({
  fontSize: "0.95rem",
  fontStyle: "italic",
  textAlign: "center",
  color: "#d1d5db",
  textShadow: "1px 1px 2px rgba(0, 0, 0, 0.6)",
});

const Team = () => {
  const { t ,i18n} = useTranslation();

  const members = t("team.members", { returnObjects: true });
  const heading = t("team.heading");
const isRTL = i18n.language === 'ar';

  const fontFamily = isRTL ? "'Tajawal', sans-serif" : 'inherit';
  return (
    <Box sx={{ px: { xs: 2, sm: 4, md: 6 }, py: 5, bgcolor: "#f8fafc" }}>
      <Typography
      fontFamily={fontFamily}
        variant="h3"
        align="center"
        gutterBottom
        sx={{
          fontWeight: 900,
          color: "dodgerblue",
          mb: 6,
          fontSize: { xs: "1.8rem", sm: "2rem", md: "2.5rem" },
     
          textShadow: "2px 2px 6px rgba(100, 116, 139, 0.2)",
          position: "relative",
          "&::after": {
            content: '""',
            position: "absolute",
            width: "80px",
            height: "4px",
            background: "linear-gradient(to right, #2563eb, #38bdf8)",
            bottom: -10,
            left: "50%",
            transform: "translateX(-50%)",
            borderRadius: 4,
          },
        }}
      >
        {heading}
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {members.map((member, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Card>
              <CardImage src={images[index]} alt={member.name} />
              <DrawerOverlay className="drawer">
                <MemberName    fontFamily={fontFamily} variant="h6">{member.name}</MemberName>
                <MemberRole    fontFamily={fontFamily} variant="body2">{member.role}</MemberRole>
              </DrawerOverlay>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Team;
